module.exports = __webpack_public_path__ + "static/media/29ADMSPC4.1b0b0616.jpg";